import { useEffect, useState } from "react";
import api from "../api/api";
import TableRowSummary from "./TableRowSummary";
import TableRowDetails from "./TableRowDetails";

export default function TableRow({ id, image, name, symbol, price, change_percentage_24h, marketCap, volume, onMobileTrade, onRowClick, selectedCoinId }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    // If modal is closed and this row is expanded, collapse it
    if (window.innerWidth >= 1024) {
      if (!selectedCoinId && isExpanded) {
        setIsExpanded(false);
      }
    }
  }, [selectedCoinId, isExpanded]);

  const notifyParent = (detailData) => {
    if (window.innerWidth >= 1024 && onRowClick) {
      onRowClick({
        id,
        detail: detailData,
        image,
        name,
        price,
        marketCap,
        volume
      });
    }
  };

  const handleToggle = async () => {
    const expanding = !isExpanded;
    setIsExpanded(expanding);
    if (expanding) {
      if (!detail) {
        try {
          const detailResponse = await api.get(`/market/${id}/detail`);
          setDetail(detailResponse.data);
          notifyParent(detailResponse.data);
        } catch (err) {
          console.error(`Failed to fetch details for ${id}:`, err);
        }
      } else {
        // Detail is already fetched, but still notify parent to reopen modal
        notifyParent(detail);
      }
    }
  };

  return (
    <>
      <TableRowSummary
        image={image}
        name={name}
        symbol={symbol}
        price={price}
        change_percentage_24h={change_percentage_24h}
        marketCap={marketCap}
        volume={volume}
        isExpanded={isExpanded}
        onClick={handleToggle}
      />
      {isExpanded && detail && (
        <TableRowDetails
          detail={detail}
          marketCap={marketCap}
          volume={volume}
          onMobileTrade={() => onMobileTrade({ id, name, symbol, current_price: price })}
        />
      )}
    </>
  );
}